'use strict';

/**
 * Checks if config has good structure and mandatory properties (tagId...)
 *
 * @param {Object} containerTypeConfig - config in adformConstants.js holding tagid, img sizes and similar (e.g. CONTAINER_TYPE_CATEGORY_CONFIG)
 * @return {boolean} - if config is valid
 */
function checkMandatoryFields(containerTypeConfig) {
    const mandatoryChecksValid = !!(
        containerTypeConfig
        && containerTypeConfig.tagId
        && containerTypeConfig.numOfBids
        && containerTypeConfig.desktop
        && containerTypeConfig.desktop.w
        && containerTypeConfig.desktop.h
        && [true, false].includes(containerTypeConfig.isInSlider)
        && [true, false].includes(containerTypeConfig.isMobileImgRequired)
    );

    if (!mandatoryChecksValid) {
        return false;
    }

    if (containerTypeConfig.isMobileImgRequired === false) {
        return true;
    }

    return !!(containerTypeConfig.mobile
        && containerTypeConfig.mobile.w
        && containerTypeConfig.mobile.h
    );
}

module.exports = {
    checkMandatoryFields: checkMandatoryFields
};
